import Admin from "./Admin"

export default function Home() {
    return (
        <Admin>
            <div>Home</div>
        </Admin>
    )
}
